// extracted by mini-css-extract-plugin
export default {"header":"style_header__9IeSd","title":"style_title__jYpeU","deleteButton":"style_deleteButton__GGCq9"};